'use strict';

var React = require('react');
var index = require('./index-01e339e9.js');
var require$$2 = require('react/jsx-runtime');
var Divider = require('./Divider-b2896e81.js');
require('tslib');
require('events');
require('@emotion/react');
require('react-dom');
require('react-intl');
require('react-hook-form');

function _interopNamespaceDefault(e) {
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

const usePreviousProps = value => {
  const ref = React__namespace.useRef({});
  React__namespace.useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};
var usePreviousProps$1 = usePreviousProps;

/**
 *
 * Demos:
 *
 * - [Badge](https://mui.com/base-ui/react-badge/#hook)
 *
 * API:
 *
 * - [useBadge API](https://mui.com/base-ui/react-badge/hooks-api/#use-badge)
 */
function useBadge(parameters) {
  const {
    badgeContent: badgeContentProp,
    invisible: invisibleProp = false,
    max: maxProp = 99,
    showZero = false
  } = parameters;
  const prevProps = usePreviousProps$1({
    badgeContent: badgeContentProp,
    max: maxProp
  });
  let invisible = invisibleProp;
  if (invisibleProp === false && badgeContentProp === 0 && !showZero) {
    invisible = true;
  }
  const {
    badgeContent,
    max = maxProp
  } = invisible ? prevProps : parameters;
  const displayValue = badgeContent && Number(badgeContent) > max ? `${max}+` : badgeContent;
  return {
    badgeContent,
    invisible,
    max,
    displayValue
  };
}

function getBadgeUtilityClass(slot) {
  return index.generateUtilityClass('MuiBadge', slot);
}
const badgeClasses = index.generateUtilityClasses('MuiBadge', ['root', 'badge', 'dot', 'standard', 'anchorOriginTopRight', 'anchorOriginBottomRight', 'anchorOriginTopLeft', 'anchorOriginBottomLeft', 'invisible', 'colorError', 'colorInfo', 'colorPrimary', 'colorSecondary', 'colorSuccess', 'colorWarning', 'overlapRectangular', 'overlapCircular',
// TODO: v6 remove the overlap value from these class keys
'anchorOriginTopLeftCircular', 'anchorOriginTopLeftRectangular', 'anchorOriginTopRightCircular', 'anchorOriginTopRightRectangular', 'anchorOriginBottomLeftCircular', 'anchorOriginBottomLeftRectangular', 'anchorOriginBottomRightCircular', 'anchorOriginBottomRightRectangular']);
var badgeClasses$1 = badgeClasses;

const _excluded = ["anchorOrigin", "className", "classes", "component", "components", "componentsProps", "children", "overlap", "color", "invisible", "max", "badgeContent", "slots", "slotProps", "showZero", "variant"];
const RADIUS_STANDARD = 10;
const RADIUS_DOT = 4;
const useThemeProps = index.createUseThemeProps();
const useUtilityClasses = ownerState => {
  const {
    color,
    anchorOrigin,
    invisible,
    overlap,
    variant,
    classes = {}
  } = ownerState;
  const slots = {
    root: ['root'],
    badge: ['badge', variant, invisible && 'invisible', `anchorOrigin${index.capitalize(anchorOrigin.vertical)}${index.capitalize(anchorOrigin.horizontal)}`, `anchorOrigin${index.capitalize(anchorOrigin.vertical)}${index.capitalize(anchorOrigin.horizontal)}${index.capitalize(overlap)}`, `overlap${index.capitalize(overlap)}`, color !== 'default' && `color${index.capitalize(color)}`]
  };
  return index.composeClasses(slots, getBadgeUtilityClass, classes);
};
const BadgeRoot = index.styled('span', {
  name: 'MuiBadge',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  position: 'relative',
  display: 'inline-flex',
  // For correct alignment with the text.
  verticalAlign: 'middle',
  flexShrink: 0
});
const BadgeBadge = index.styled('span', {
  name: 'MuiBadge',
  slot: 'Badge',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.badge, styles[ownerState.variant], styles[`anchorOrigin${index.capitalize(ownerState.anchorOrigin.vertical)}${index.capitalize(ownerState.anchorOrigin.horizontal)}${index.capitalize(ownerState.overlap)}`], ownerState.color !== 'default' && styles[`color${index.capitalize(ownerState.color)}`], ownerState.invisible && styles.invisible];
  }
})(({
  theme
}) => {
  var _theme$vars;
  return {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    boxSizing: 'border-box',
    fontFamily: theme.typography.fontFamily,
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: theme.typography.pxToRem(12),
    minWidth: RADIUS_STANDARD * 2,
    lineHeight: 1,
    padding: '0 6px',
    height: RADIUS_STANDARD * 2,
    borderRadius: RADIUS_STANDARD,
    zIndex: 1,
    // Render the badge on top of potential ripples.
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.easeInOut,
      duration: theme.transitions.duration.enteringScreen
    }),
    variants: [...Object.keys(((_theme$vars = theme.vars) != null ? _theme$vars : theme).palette).filter(key => {
      var _theme$vars2, _theme$vars3;
      return ((_theme$vars2 = theme.vars) != null ? _theme$vars2 : theme).palette[key].main && ((_theme$vars3 = theme.vars) != null ? _theme$vars3 : theme).palette[key].contrastText;
    }).map(color => ({
      props: {
        color
      },
      style: {
        backgroundColor: (theme.vars || theme).palette[color].main,
        color: (theme.vars || theme).palette[color].contrastText
      }
    })), {
      props: {
        variant: 'dot'
      },
      style: {
        borderRadius: RADIUS_DOT,
        height: RADIUS_DOT * 2,
        minWidth: RADIUS_DOT * 2,
        padding: 0
      }
    }, {
      props: ({
        ownerState
      }) => ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'rectangular',
      style: {
        top: 0,
        right: 0,
        transform: 'scale(1) translate(50%, -50%)',
        transformOrigin: '100% 0%',
        [`&.${badgeClasses$1.invisible}`]: {
          transform: 'scale(0) translate(50%, -50%)'
        }
      }
    }, {
      props: ({
        ownerState
      }) => ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'rectangular',
      style: {
        bottom: 0,
        right: 0,
        transform: 'scale(1) translate(50%, 50%)',
        transformOrigin: '100% 100%',
        [`&.${badgeClasses$1.invisible}`]: {
          transform: 'scale(0) translate(50%, 50%)'
        }
      }
    }, {
      props: ({
        ownerState
      }) => ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'rectangular',
      style: {
        top: 0,
        left: 0,
        transform: 'scale(1) translate(-50%, -50%)',
        transformOrigin: '0% 0%',
        [`&.${badgeClasses$1.invisible}`]: {
          transform: 'scale(0) translate(-50%, -50%)'
        }
      }
    }, {
      props: ({
        ownerState
      }) => ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'rectangular',
      style: {
        bottom: 0,
        left: 0,
        transform: 'scale(1) translate(-50%, 50%)',
        transformOrigin: '0% 100%',
        [`&.${badgeClasses$1.invisible}`]: {
          transform: 'scale(0) translate(-50%, 50%)'
        }
      }
    }, {
      props: ({
        ownerState
      }) => ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'circular',
      style: {
        top: '14%',
        right: '14%',
        transform: 'scale(1) translate(50%, -50%)',
        transformOrigin: '100% 0%',
        [`&.${badgeClasses$1.invisible}`]: {
          transform: 'scale(0) translate(50%, -50%)'
        }
      }
    }, {
      props: ({
        ownerState
      }) => ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'circular',
      style: {
        bottom: '14%',
        right: '14%',
        transform: 'scale(1) translate(50%, 50%)',
        transformOrigin: '100% 100%',
        [`&.${badgeClasses$1.invisible}`]: {
          transform: 'scale(0) translate(50%, 50%)'
        }
      }
    }, {
      props: ({
        ownerState
      }) => ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'circular',
      style: {
        top: '14%',
        left: '14%',
        transform: 'scale(1) translate(-50%, -50%)',
        transformOrigin: '0% 0%',
        [`&.${badgeClasses$1.invisible}`]: {
          transform: 'scale(0) translate(-50%, -50%)'
        }
      }
    }, {
      props: ({
        ownerState
      }) => ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'circular',
      style: {
        bottom: '14%',
        left: '14%',
        transform: 'scale(1) translate(-50%, 50%)',
        transformOrigin: '0% 100%',
        [`&.${badgeClasses$1.invisible}`]: {
          transform: 'scale(0) translate(-50%, 50%)'
        }
      }
    }, {
      props: {
        invisible: true
      },
      style: {
        transition: theme.transitions.create('transform', {
          easing: theme.transitions.easing.easeInOut,
          duration: theme.transitions.duration.leavingScreen
        })
      }
    }]
  };
});
const Badge = /*#__PURE__*/React__namespace.forwardRef(function Badge(inProps, ref) {
  var _ref, _slots$root, _ref2, _slots$badge, _slotProps$root, _slotProps$badge;
  const props = useThemeProps({
    props: inProps,
    name: 'MuiBadge'
  });
  const {
      anchorOrigin: anchorOriginProp = {
        vertical: 'top',
        horizontal: 'right'
      },
      className,
      component,
      components = {},
      componentsProps = {},
      children,
      overlap: overlapProp = 'rectangular',
      color: colorProp = 'default',
      invisible: invisibleProp = false,
      max: maxProp = 99,
      badgeContent: badgeContentProp,
      slots,
      slotProps,
      showZero = false,
      variant: variantProp = 'standard'
    } = props,
    other = index._objectWithoutPropertiesLoose(props, _excluded);
  const {
    badgeContent,
    invisible: invisibleFromHook,
    max,
    displayValue: displayValueFromHook
  } = useBadge({
    max: maxProp,
    invisible: invisibleProp,
    badgeContent: badgeContentProp,
    showZero
  });
  const prevProps = usePreviousProps$1({
    anchorOrigin: anchorOriginProp,
    color: colorProp,
    overlap: overlapProp,
    variant: variantProp,
    badgeContent: badgeContentProp
  });
  const invisible = invisibleFromHook || badgeContent == null && variantProp !== 'dot';
  const {
    color = colorProp,
    overlap = overlapProp,
    anchorOrigin = anchorOriginProp,
    variant = variantProp
  } = invisible ? prevProps : props;
  const displayValue = variant !== 'dot' ? displayValueFromHook : undefined;
  const ownerState = index._extends({}, props, {
    badgeContent,
    invisible,
    max,
    displayValue,
    showZero,
    anchorOrigin,
    color,
    overlap,
    variant
  });
  const classes = useUtilityClasses(ownerState);

  // support both `slots` and `components` for backward compatibility
  const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : BadgeRoot;
  const BadgeSlot = (_ref2 = (_slots$badge = slots == null ? void 0 : slots.badge) != null ? _slots$badge : components.Badge) != null ? _ref2 : BadgeBadge;
  const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
  const badgeSlotProps = (_slotProps$badge = slotProps == null ? void 0 : slotProps.badge) != null ? _slotProps$badge : componentsProps.badge;
  const rootProps = index.useSlotProps({
    elementType: RootSlot,
    externalSlotProps: rootSlotProps,
    externalForwardedProps: other,
    additionalProps: {
      ref,
      as: component
    },
    ownerState,
    className: index.clsx(rootSlotProps == null ? void 0 : rootSlotProps.className, classes.root, className)
  });
  const badgeProps = index.useSlotProps({
    elementType: BadgeSlot,
    externalSlotProps: badgeSlotProps,
    ownerState,
    className: index.clsx(classes.badge, badgeSlotProps == null ? void 0 : badgeSlotProps.className)
  });
  return /*#__PURE__*/require$$2.jsxs(RootSlot, index._extends({}, rootProps, {
    children: [children, /*#__PURE__*/require$$2.jsx(BadgeSlot, index._extends({}, badgeProps, {
      children: displayValue
    }))]
  }));
});
process.env.NODE_ENV !== "production" ? Badge.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The anchor of the badge.
   * @default {
   *   vertical: 'top',
   *   horizontal: 'right',
   * }
   */
  anchorOrigin: index.PropTypes.shape({
    horizontal: index.PropTypes.oneOf(['left', 'right']).isRequired,
    vertical: index.PropTypes.oneOf(['bottom', 'top']).isRequired
  }),
  /**
   * The content rendered within the badge.
   */
  badgeContent: index.PropTypes.node,
  /**
   * The badge will be added relative to this node.
   */
  children: index.PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: index.PropTypes.object,
  /**
   * @ignore
   */
  className: index.PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: index.PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([index.PropTypes.oneOf(['default', 'primary', 'secondary', 'error', 'info', 'success', 'warning']), index.PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: index.PropTypes.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: index.PropTypes.shape({
    Badge: index.PropTypes.elementType,
    Root: index.PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: index.PropTypes.shape({
    badge: index.PropTypes.oneOfType([index.PropTypes.func, index.PropTypes.object]),
    root: index.PropTypes.oneOfType([index.PropTypes.func, index.PropTypes.object])
  }),
  /**
   * If `true`, the badge is invisible.
   * @default false
   */
  invisible: index.PropTypes.bool,
  /**
   * Max count to show.
   * @default 99
   */
  max: index.PropTypes.number,
  /**
   * Wrapped shape the badge should overlap.
   * @default 'rectangular'
   */
  overlap: index.PropTypes.oneOf(['circular', 'rectangular']),
  /**
   * Controls whether the badge is hidden when `badgeContent` is zero.
   * @default false
   */
  showZero: index.PropTypes.bool,
  /**
   * The props used for each slot inside the Badge.
   * @default {}
   */
  slotProps: index.PropTypes.shape({
    badge: index.PropTypes.oneOfType([index.PropTypes.func, index.PropTypes.object]),
    root: index.PropTypes.oneOfType([index.PropTypes.func, index.PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Badge.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: index.PropTypes.shape({
    badge: index.PropTypes.elementType,
    root: index.PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: index.PropTypes.oneOfType([index.PropTypes.arrayOf(index.PropTypes.oneOfType([index.PropTypes.func, index.PropTypes.object, index.PropTypes.bool])), index.PropTypes.func, index.PropTypes.object]),
  /**
   * The variant to use.
   * @default 'standard'
   */
  variant: index.PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([index.PropTypes.oneOf(['dot', 'standard']), index.PropTypes.string])
} : void 0;
var Badge$1 = Badge;

const theme$1 = index.createTheme(index.theme$1, {
    components: {
        MuiBadge: {
            styleOverrides: {
                root: {
                    width: 'fit-content',
                },
                badge: {
                    top: 0,
                    right: 0,
                },
            },
        },
        MuiSelect: {
            defaultProps: {
                multiple: true,
                value: [],
            },
        },
    },
});

const theme = index.createTheme(index.theme$2, {
    components: {
        MuiBadge: {
            styleOverrides: {
                root: {
                    width: 'fit-content',
                },
                badge: {
                    top: 0,
                    right: 0,
                },
            },
        },
        MuiSelect: {
            defaultProps: {
                multiple: true,
                value: [],
            },
        },
    },
});

const renderText = (selected, options) => {
    const formattedSelected = selected.map((value) => {
        const selectedOption = index.findSelectedOption(options, value);
        return (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.text) || '';
    });
    return formattedSelected.join(', ');
};

const useMultiSelectHook = ({ id, displayValue, placeholder, name, value, renderValue, options, }) => {
    const selectRef = React.useRef(null);
    const [showBadge, setShowBadge] = React.useState(false);
    React.useLayoutEffect(() => {
        var _a;
        if (value && (value === null || value === void 0 ? void 0 : value.length) > 1 && ((_a = selectRef === null || selectRef === void 0 ? void 0 : selectRef.current) === null || _a === void 0 ? void 0 : _a.children)) {
            const { clientWidth, scrollWidth } = selectRef.current.children[0];
            if (clientWidth < scrollWidth) {
                setShowBadge(true);
            }
            else if (showBadge) {
                setShowBadge(false);
            }
        }
        else if (showBadge) {
            setShowBadge(false);
        }
    }, [showBadge, value]);
    const handleRenderValue = React.useCallback((selected) => {
        let returnValue = placeholder;
        const selectedValue = selected;
        if (renderValue) {
            returnValue = renderValue(selectedValue, options);
        }
        else if (displayValue) {
            returnValue = selectedValue.join(', ');
        }
        else if (selected === null || selected === void 0 ? void 0 : selected.length) {
            returnValue = renderText(selectedValue, options);
        }
        return returnValue;
    }, [displayValue, options, placeholder, renderValue]);
    const inputId = id !== null && id !== void 0 ? id : `${name}_multiSelect`;
    const labelId = `${name}_label`;
    const helperTextId = `${name}_helperText`;
    return {
        handleRenderValue,
        helperTextId,
        inputId,
        labelId,
        selectRef,
        showBadge,
    };
};

const NO_PREFERENCE_UUID = 'noPreference';
const NO_PREFERENCE_OPTION = {
    value: NO_PREFERENCE_UUID,
    text: 'No Preference',
    disabled: false,
};
const useNoPreferenceSelectionHook = ({ value, onChange, options, noPreferenceOptionEnabled, noPreferenceOption, }) => {
    var _a;
    const finalNoPreferenceOption = noPreferenceOption !== null && noPreferenceOption !== void 0 ? noPreferenceOption : NO_PREFERENCE_OPTION;
    const noPreferenceValue = (_a = noPreferenceOption === null || noPreferenceOption === void 0 ? void 0 : noPreferenceOption.value) !== null && _a !== void 0 ? _a : NO_PREFERENCE_UUID;
    const isNoPreferenceOptionSelected = value
        ? !index.isNil(value.find((o) => o === noPreferenceValue))
        : false;
    const didMountRef = React.useRef(false);
    React.useEffect(() => {
        if (didMountRef.current && isNoPreferenceOptionSelected && onChange) {
            onChange([noPreferenceValue]);
        }
        didMountRef.current = true;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isNoPreferenceOptionSelected]);
    const optionsWithNoPreference = [
        finalNoPreferenceOption,
    ].concat(options);
    const handleDisablingOptionsWhenNoPreferenceSelected = React.useCallback((value) => noPreferenceOptionEnabled
        ? isNoPreferenceOptionSelected && value !== noPreferenceValue
        : false, [isNoPreferenceOptionSelected, noPreferenceOptionEnabled, noPreferenceValue]);
    return {
        isNoPreferenceOptionSelected: noPreferenceOptionEnabled
            ? isNoPreferenceOptionSelected
            : false,
        handleDisablingOptionsWhenNoPreferenceSelected,
        optionsWithNoPreference,
    };
};

/** https://mui.com/components/selects/ */
const MultiSelect = React.forwardRef(({ InputLabelProps, IconComponent, autoWidth, checkmarkIcon, checkmarks, disabled, displayEmpty, displayValue, error, focused, fullWidth, helperText, label, labelAction, margin, name, noPreferenceOptionEnabled, noPreferenceOption, onChange = () => { }, onClose = () => { }, options: baseOptions = [], placeholder, readOnly, renderValue, required, selectAllOption, sx, value, excludeFromSelectAll = [], onBlur, }, ref) => {
    const { optionsWithNoPreference, isNoPreferenceOptionSelected, handleDisablingOptionsWhenNoPreferenceSelected, } = useNoPreferenceSelectionHook({
        noPreferenceOptionEnabled,
        noPreferenceOption,
        value,
        onChange,
        options: baseOptions,
    });
    const options = noPreferenceOptionEnabled
        ? optionsWithNoPreference
        : baseOptions;
    const { handleRenderValue, helperTextId, inputId, labelId, selectRef, showBadge, } = useMultiSelectHook({
        displayValue,
        placeholder,
        value,
        name,
        label,
        renderValue,
        options,
    });
    const handleSelectAll = (event) => {
        event.stopPropagation();
        const allOptions = options === null || options === void 0 ? void 0 : options.map(({ value }) => value);
        const filtered = allOptions.filter((value) => !excludeFromSelectAll.includes(value));
        onChange(filtered);
    };
    const getSizeAll = () => {
        const size = options.length - excludeFromSelectAll.length;
        return size;
    };
    return (React.createElement(index.MultiThemeProvider, { fortressTheme: theme$1, portalTheme: theme }, (themeName) => (React.createElement(index.MuiFormControl, { disabled: disabled, error: error, focused: focused, fullWidth: fullWidth, margin: margin, required: required, sx: sx },
        label && (React.createElement(index.SingleSelectLabel, Object.assign({}, InputLabelProps, { disabled: disabled, error: error, focused: focused, htmlFor: inputId, id: labelId, label: label, labelAction: labelAction, readOnly: readOnly, required: required }))),
        React.createElement(Badge$1, { badgeContent: (value === null || value === void 0 ? void 0 : value.length) || '', color: 'primary', invisible: !showBadge, sx: {
                width: fullWidth ? '100%' : 'fit-content',
                // @ts-ignore
                transition: sx === null || sx === void 0 ? void 0 : sx.transition,
                // @ts-ignore
                opacity: sx === null || sx === void 0 ? void 0 : sx.opacity,
            } },
            React.createElement(index.MuiSelect, { ref: selectRef, IconComponent: IconComponent, name: name, autoWidth: autoWidth, displayEmpty: displayEmpty || !!(placeholder === null || placeholder === void 0 ? void 0 : placeholder.length), disabled: disabled, label: label, labelId: labelId, id: inputId, readOnly: readOnly, value: value, onChange: ({ target: { value } }) => {
                    onChange(value);
                }, onClose: onClose, input: React.createElement(index.OutlinedInput, { ref: ref }), inputProps: {
                    name,
                    'aria-label': labelId,
                }, renderValue: handleRenderValue, onBlur: onBlur },
                React.createElement(index.Collapse, { in: selectAllOption },
                    React.createElement("div", null,
                        React.createElement(index.MenuItem, { sx: {
                                color: 'primary.dark',
                                fontWeight: 400,
                            }, disabled: !(options === null || options === void 0 ? void 0 : options.length) ||
                                (value === null || value === void 0 ? void 0 : value.length) === options.length ||
                                (value === null || value === void 0 ? void 0 : value.length) === getSizeAll(), onClick: handleSelectAll }, `Select All (${getSizeAll() || 0})`),
                        React.createElement(Divider.Divider, null))),
                options.map((option) => {
                    const selected = (value !== null && value !== void 0 ? value : []).includes(option.value);
                    const customCheckMarkIcon = checkmarkIcon
                        ? { checkedIcon: checkmarkIcon }
                        : {};
                    return (React.createElement(index.MenuItem, { key: option.value, disabled: option.disabled ||
                            handleDisablingOptionsWhenNoPreferenceSelected(option.value), value: option.value },
                        checkmarks && (React.createElement(index.Checkbox, Object.assign({ checked: selected, label: '' }, customCheckMarkIcon))),
                        option.text));
                }),
                React.createElement(index.Collapse, { in: !isNoPreferenceOptionSelected },
                    React.createElement("div", null,
                        React.createElement(Divider.Divider, { sx: { marginTop: 1, marginBottom: 1 } }),
                        React.createElement(index.MenuItem, { sx: {
                                color: 'secondary.dark',
                                fontWeight: 400,
                            }, disabled: !(value === null || value === void 0 ? void 0 : value.length), onClick: () => onChange([]) }, `Clear All (${(value === null || value === void 0 ? void 0 : value.length) || 0}) Selected`))))),
        React.createElement(index.FormHelperText, { "data-testid": 'helperText', disabled: disabled, error: error, required: required, id: helperTextId }, index.determineHelperText({ themeName, required, helperText }))))));
});
MultiSelect.displayName = 'MultiSelect';
MultiSelect.defaultProps = {
    disabled: false,
    displayValue: false,
    placeholder: 'Select all that apply',
    options: [],
    value: [],
    name: '',
    checkmarks: true,
    fullWidth: true,
    onChange: () => { },
    excludeFromSelectAll: [],
    // @ts-ignore
    IconComponent: index.SingleSelect === null || index.SingleSelect === void 0 ? void 0 : index.SingleSelect.defaultProps.IconComponent,
};

exports.default = MultiSelect;
